import * as React from 'react'

export const CertIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
		<g id="Иконка" transform="translate(-5 -2)">
			<rect id="Фон" width="32" height="32" transform="translate(5 2)" fill="none" />
			<g id="Контент" transform="translate(0 -1)">
				<path id="Контур_11912" data-name="Контур 11912" d="M7,12H25a1,1,0,0,0,0-2H7a1,1,0,0,0,0,2Z" transform="translate(5 2)" fill="currentColor" />
				<path id="Контур_11913" data-name="Контур 11913" d="M7,17h8a1,1,0,0,0,0-2H7a1,1,0,0,0,0,2Z" transform="translate(5 2)" fill="currentColor" />
				<path id="Контур_11914" data-name="Контур 11914" d="M7,22h6a1,1,0,0,0,0-2H7a1,1,0,0,0,0,2Z" transform="translate(5 2)" fill="currentColor" />
				<path id="Контур_11915" data-name="Контур 11915" d="M30,4H2A2,2,0,0,0,0,6V26a2,2,0,0,0,2,2H19v4a1,1,0,0,0,.59.91L22.5,30l2.91,2.91A1,1,0,0,0,26,32V28h4a2,2,0,0,0,2-2V6A2,2,0,0,0,30,4ZM24,24.79v3.88l-.09-.08a2,2,0,0,0-2.82,0l-.09.08V24.79h0a5.53,5.53,0,0,0,3,0ZM22.5,23A3.5,3.5,0,1,1,26,19.5,3.5,3.5,0,0,1,22.5,23ZM30,26H26V23.74h0a5.5,5.5,0,1,0-6.92,0h0V26H2V6H30Z" transform="translate(5 2)" fill="currentColor" />
			</g>
		</g>
	</svg>
)

